"use client";

import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import { isItemDaily } from "./nav-config";

/** "Your sidebar": tick what stays visible; the rest sits under Show more. */
export function SidebarCustomize({
  items,
  daily,
  onToggle,
  onReset,
  onClose,
}: {
  items: { id: string; label: string }[];
  daily: { id: string }[];
  onToggle: (id: string, defaultIsDaily: boolean) => void;
  onReset: () => void;
  onClose: () => void;
}) {
  return (
    <Modal open onClose={onClose} size="sm" title="Your sidebar">
      <p className="mb-3 text-sm text-muted">Ticked items are always visible; the others sit under Show more.</p>
      <ul className="max-h-[60vh] space-y-0.5 overflow-y-auto">
        {items.map((item) => (
          <li key={item.id}>
            <label className="flex cursor-pointer items-center gap-3 rounded-lg px-2 py-1.5 text-sm text-fg hover:bg-surface-muted">
              <input type="checkbox" checked={daily.some((d) => d.id === item.id)} onChange={() => onToggle(item.id, isItemDaily(item.id))} className="h-4 w-4 rounded border-line-strong accent-[var(--color-accent)]" />
              {item.label}
            </label>
          </li>
        ))}
      </ul>
      <div className="mt-4 flex justify-between border-t border-line pt-3">
        <Button variant="ghost" size="sm" onClick={onReset}>Back to default</Button>
        <Button variant="primary" size="sm" onClick={onClose}>Done</Button>
      </div>
    </Modal>
  );
}
